import gql from 'graphql-tag';

export default gql`
  mutation orderDisapprove($orderId: ID!) {
    orderDisapprove(orderId: $orderId) {
      success
      userErrors {
        field
        message
      }
      order {
        id
        total
        items {
          total
          price
          note
          discount
          orderedPrice
          orderedPriceV2 {
            price
            vat
            vatIncluded
          }
          priceV2 {
            price
            vat
            vatIncluded
          }
          totalBeforeVat
          product {
            id
            name
            note
            price
            vat
            uom
            uomLocal
            inStock
            supplierInternalCode
            imageUrl
          }
          deliveryQuantity
          orderedQuantity
          deliveredNote

          buyerNote
        }
        orderDate
        deliveryTime {
          start
          end
        }
        status
        statusText
        note
        buyer {
          id
          name
        }
        store {
          id
          name
          freeShipping
          moq
        }
        supplier {
          id
          name
          imageUrl
          location {
            address
            district
            city
          }
        }
        creator {
          id
          name
        }
        paymentMethod
        redelivery
      }
    }
  }
`;
